import { notifierStore } from "src/framework/store/NotifierStore";

export const mostrarAvisoServicoRemovido = () => {
  notifierStore.setNotifier({
    title: 'Atenção!',
    content: [
      '<u>Importante</u>: Valor de serviço removido.',
      'Revenda não habilitada para venda com valor de serviço.',
    ],
    timeOut: 10000,
    onClose: () => {
      notifierStore.setOpen(false)
    },
  });
  notifierStore.setOpen(true);
};